import { useCallback } from 'react'

import { DrawingParameterPolyline, DrawingType } from '@editor/interfaces/drawing'
import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { removeDrawings } from '@editor/pages/projects/blueprint-editor/store/drawings'
import { getDrawingsOfType } from '@editor/services/Drawing'
import { RootState, useAppDispatch } from '@editor/store/app'
import { resetElement } from '@editor/store/tool'
import { useSelector } from 'react-redux'

import { getLastCount } from '../../utils'
import { reset } from '../store'

const useDrawingsPanel = (): ElementsPanelConfig => {
  // Store
  const dispatch = useAppDispatch()
  const drawings = useSelector((state: RootState) => state.blueprint.drawings.document.drawings)
  const workingPoints = useSelector((state: RootState) => state.bpToolPen.workingPoints)

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item']): EditorPanelItem[] => {
        if (parent) return [] as EditorPanelItem[]

        const results: EditorPanelItem[] = getDrawingsOfType<DrawingParameterPolyline>(
          drawings,
          DrawingType.Polyline,
          [],
        ).map((item, index) => ({
          key: `tool-pen-drawing-${item.drawing_parameters.uuid}`,
          name: item.name || `ポリライン ${index + 1}`,
          item,
          onDelete: () => {
            dispatch(removeDrawings([item.drawing_parameters.uuid]))
            dispatch(resetElement(item.drawing_parameters.uuid))
          },
        }))

        if (workingPoints.length > 0) {
          results.push({
            key: 'tool-pen-working-panel-item',
            name: `ポリライン ${
              getLastCount(
                drawings.map((p) => p.name),
                'ポリライン',
              ) + 1
            }`,
            isWorking: true,
            onDelete: () => dispatch(reset()),
          })
        }

        return results
      },
      [drawings, workingPoints.length, dispatch],
    ),
  }
}

export default useDrawingsPanel
